<template>
  <base-dialog width="485px" class="add-new-participant-dialog" :visible.sync="visible" show-close>
    <template v-slot:header>
      {{ title || "选择人员范围" }}
    </template>
    <el-form v-loading="loading">
      <el-form-item label="请选择">
        <user-scope-selector
          v-model="userScopeData"
          :users="curUsers"
          :tip="title"
          :root-department="rootDepartment"
          v-bind="$attrs"
        ></user-scope-selector>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <base-button @click="visible = false">取消</base-button>
      <base-button type="primary" @click="submit">确认</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import UserScopeSelector from "@/components/UIComponents/UserScopeSelector"
import { getCompanyUsers, getDepartmentTree } from "@/api/userCenter/company"
import { getAppUsers } from "@/api/user"

export default {
  name: "SelectUserScopeDialog",
  components: { BaseButton, BaseDialog, UserScopeSelector },
  props: {
    title: String,
    scope: String // app, company
  },
  data() {
    return {
      visible: false,
      userScopeData: [],
      curUsers: [],
      loading: false,
      rootDepartment: {}
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    open() {
      this.visible = true
      this.userScopeData = []
      this.init()
    },
    init() {
      this.loading = true
      let promises = [
        getDepartmentTree({ companyId: this.curUser.companyId }).then(departmentTree => {
          this.rootDepartment = departmentTree[0]
        })
      ]
      switch (this.scope) {
        case "app":
          promises.push(
            getAppUsers({ appId: this.curUser.appId }).then(res => (this.curUsers = res))
          )
          break
        case "company":
          promises.push(
            getCompanyUsers({ companyId: this.curUser.companyId }).then(
              res => (this.curUsers = res)
            )
          )
          break
      }
      Promise.all(promises).finally(() => (this.loading = false))
    },
    submit() {
      this.$emit("select", this.userScopeData)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-participant-dialog {
  .el-form {
    margin-top: 18px;
    ::v-deep {
      .el-form-item__content {
        display: flex;
        .el-select {
          flex: 1;
        }
        > span {
          flex: 1;
        }
      }
    }
  }
}
</style>
